<template>
    <b-form-group label-for="gender">
        <template slot="label"
            >{{ $t("pages.forms.common.gender-baby-teens.title")
            }}<span v-if="required" :class="requiredClasses">*</span></template
        >
        <validation-provider
            :rules="{ required, oneOf: [1, 0] }"
            v-slot="{ dirty, validated, valid, errors }"
        >
            <b-form-group v-show="!isInReview">
                <b-form-radio-group
                    id="gender"
                    v-model="gender"
                    :options="genderOptions"
                    name="gender"
                    :state="dirty || validated ? valid : null"
                    :required="required"
                    @input="update"
                >
                    <b-form-invalid-feedback
                        :state="dirty || validated ? valid : null"
                        >{{ errors[0] }}</b-form-invalid-feedback
                    >
                </b-form-radio-group>
            </b-form-group>
        </validation-provider>
        <b-form-input
            type="text"
            :value="genderForDisplay"
            readonly
            plaintext
            v-show="isInReview"
        />
    </b-form-group>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import FormInputHelpers from "../../../mixins/FormInputHelpers";

export default {
    mixins: [FormInputHelpers],
    components: { ValidationProvider },
    data() {
        return {
            gender: null
        };
    },
    props: {
        value: null,
        required: {
            type: Boolean,
            default: false
        },
        inReview: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update(value) {
            this.$emit("input", value);
        }
    },
    computed: {
        genderOptions() {
            return [
                {
                    text: this.$i18n.t(
                        "pages.forms.common.gender-baby-teens.options.male"
                    ),
                    value: 1
                },
                {
                    text: this.$i18n.t(
                        "pages.forms.common.gender-baby-teens.options.female"
                    ),
                    value: 0
                }
            ];
        },
        genderForDisplay() {
            return null !== this.gender
                ? this.genderOptions.filter(e => e.value === this.gender).pop()
                      .text
                : "";
        },
        isInReview() {
            return this.inReview;
        }
    }
};
</script>
